var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnPass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      position: "absolute",
      top: "-5px"
    },
    width: 106,
    height: 48,
    viewBox: "0 0 106 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0774 20.0774C26.4028 19.752 26.9305 19.752 27.2559 20.0774L30 22.8214L32.7441 20.0773C33.0695 19.7519 33.5972 19.7519 33.9226 20.0773C34.248 20.4028 34.248 20.9304 33.9226 21.2558L31.1785 24L33.9226 26.7441C34.248 27.0695 34.248 27.5972 33.9226 27.9226C33.5972 28.248 33.0695 28.248 32.7441 27.9226L30 25.1785L27.2559 27.9225C26.9305 28.2479 26.4028 28.2479 26.0774 27.9225C25.752 27.5971 25.752 27.0694 26.0774 26.744L28.8214 24L26.0774 21.2559C25.752 20.9305 25.752 20.4028 26.0774 20.0774Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 34C35.5228 34 40 29.5228 40 24C40 18.4772 35.5228 14 30 14C24.4772 14 20 18.4772 20 24C20 29.5228 24.4772 34 30 34ZM30 32.3333C34.6024 32.3333 38.3333 28.6024 38.3333 24C38.3333 19.3976 34.6024 15.6667 30 15.6667C25.3976 15.6667 21.6667 19.3976 21.6667 24C21.6667 28.6024 25.3976 32.3333 30 32.3333Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPass);
export default __webpack_public_path__ + "static/media/btn-pass.ad49beb7f493c493de54aa172845e9c2.svg";
export { ForwardRef as ReactComponent };